import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import Tracker from '@openreplay/tracker';
import * as Sentry from "@sentry/angular";

if (environment.production) {
  enableProdMode();
  // Lazy-start OpenReplay only when a user is signed in
  (window as any).startOpenReplay = () => {
    if ((window as any).tracker) return; // already started
    const tracker = new Tracker({
      projectKey: "s95fWBAUkXTWmWQ76Som",
    });
    tracker.start();
    (window as any).tracker = tracker;
  };
}

['log', 'warn', 'error', 'info'].forEach(level => {
  const original = console[level as keyof Console];
  console[level as keyof Console] = (...args: any[]) => {
    let message = '';
    try {
      message = args.map(a =>
        typeof a === 'string' ? a : JSON.stringify(a)
      ).join(' ');
    } catch (e) {
      message = '[Unserializable console argument]';
    }

    Sentry.addBreadcrumb({
      category: 'console',
      message,
      level: level as Sentry.SeverityLevel,
    });

    original.apply(console, args);
  };
});

Sentry.init({
  dsn: (environment as any).SENTRY_DNS || '',
  environment: environment.production ? 'Production' : 'Stag',
  beforeSend(event, hint) {
  // Ignore events that are not errors
  if (!event.exception || !event.exception.values || event.exception.values.length === 0) {
    return null;
  }
  // Ignore third-party errors based on stack trace domains
  const stacktrace = event.exception?.values?.[0]?.stacktrace?.frames || [];
  const thirdPartyDomains = ['chatbase.co', 'googleapis.com', 'intercom.io'];
  const isFromThirdParty = stacktrace.some(frame =>
    thirdPartyDomains.some(domain =>
      (frame?.filename || '').toLowerCase().includes(domain)
    )
  );
  if (isFromThirdParty) {
    console.warn('Ignored third-party error:', event);
    return null;
  }
  //------------------------------------------------------------------------

  if (event.exception && event.event_id) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  },
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      isNameRequired: true,
      isEmailRequired: true,
      autoInject: false
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    }),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
